import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import SubNav from "../../navbar/subNav";
import "../PropertiesAgency/ViewPropertyDetails.css";
import { ContactDetailsApi} from "../../../components/CommonSection/apiresources";
import { makeRequestWithSpinner, DownloadFiletWithSpinner } from "../../../Utilities/client";
import { GetCookie, currentProfile } from "../../../components/CommonSection/Cookie/Session";
import { useSpinnerContext } from "../../../Utilities/SpinnerContext";
import { ActionStatus } from "../../../Utilities/enum";
import { Table, Button, Select, Input, Space, Dropdown,Tag } from "antd";
import { DownloadOutlined, PlusOutlined, UploadOutlined, DollarOutlined, EditOutlined, DeleteOutlined } from "@ant-design/icons";
import moment from "moment";
import axios from "axios";
import ToastAlert from "../../../components/CommonSection/ToastAlert/ToastAlert";
import ShowValue from "../../input-components/ShowValue";
import { format } from 'date-fns';

const ViewContactDetails = ({ }) => {
    const [userId, setUserId] = useState("");
    const [agencyID, setAgencyId] = useState("");
    const [activeTab, setActiveTab] = useState("Overview");
    const [getDetails, setGetDetails] = useState(null);
    const [selectedCountries, setSelectedCountries] = useState(null);
    const [folioDetailsOwner , setFolioDetailsOwner] = useState({});
    const [folioDetailsSupplier , setFolioDetailsSupplier] = useState({});
    const [folioDetailsTenant , setFolioDetailsTenant] = useState({});
    const [typeData, setTypeData] = useState([
        { value: 1, label: "Individual" },
        { value: 2, label: "Company" },
    ]);
    const [titleData, setTitleData] = useState([
        { value: 1, label: "Mr." },
        { value: 2, label: "Miss." },
        { value: 3, label: "Mrs." },
    ]);
    const [budgetData, setBudgetData] = useState([
        { value: 1, label: "$700000 & below" },
        { value: 2, label: "1M below" },
        { value: 3, label: "1M to 1.2M" },
        { value: 4, label: "$1.2 M & above" },
    ]);
    const { showSpinner, hideSpinner } = useSpinnerContext();
    const navigate = useNavigate();
    const ToastRef = useRef();
    var url = new URL(window.location.href);
    var contactUID = url.searchParams.get("contactUID");
    var folio = url.searchParams.get("folio");

    const tabs = ["Overview", folio === "Owner" ? "Owner Folio" : folio === "Supplier" ? "Supplier Folio" : folio === "Tenant" ? "Tenant Folio" : ""];
     const options = [
        { value: 1, label: "Seller" },
        { value: 2, label: "Buyer" },
        { value: 3, label: "Investor" },
        { value: 4, label: "Tenant" },
        { value: 5, label: "Landlord" },
        { value: 6, label: "Developer" },
        { value: 7, label: "Supplier" },
    ];

    useEffect(() => {
        if (contactUID) {
            GetApi(contactUID)
        }
    }, [])

    useEffect(() => {
        if (getDetails?.postcode != null) {
            setSelectedCountries(getDetails.postcode.split(";"));
        }
    }, [])


    useEffect(() => {
        const retrieveData = async () => {
            try {
                const userData = GetCookie("@UserData");
                if (userData) {
                    const parsedData = JSON.parse(userData);
                    setUserId(parsedData.userId);
                    setAgencyId(parsedData.agencyID);
                } else {
                    navigate("/signin");
                }
            } catch (error) {
                console.error("Error retrieving data:", error);
            }
        };
        retrieveData();
    }, [userId]);


     const GetApi = (value) => {
            var url = new URL(window.location.href);
            var contactUniqueId = value ? value : url.searchParams.get("contactUID");
            const baseUrl = ContactDetailsApi;
            const apiUrl = `${baseUrl}?contactUniqueId=${contactUniqueId}`;
            makeRequestWithSpinner(showSpinner, hideSpinner, apiUrl, "get")
                .then((response) => {
                    if (response.status === ActionStatus.Successfull) {
                        setGetDetails(response.object);
                        setFolioDetailsOwner(response.object?.propertyOwnerFolioDetails);
                        setFolioDetailsSupplier(response.object?.supplierDetails);
                        setFolioDetailsTenant(response.object?.tenantFolioDetails);
                    } else {
                        ToastRef.current.notify(["error", response.data.message]);
    
                    }
                })
        };

   
    const handleTabs = (tabs) => {
        setActiveTab(tabs);
    }

     const commaSeparatedString =
        getDetails?.typeIAM && typeof getDetails?.typeIAM === "string"
            ? getDetails?.typeIAM
                .split(",")
                .map((value) => {
                    const option = options.find((opt) => opt.value === parseInt(value));
                    return option ? option.label : null;
                })
                .filter((label) => label !== null)
                .join(", ")
            : null;

    const commaSeparatedString1 =
        getDetails?.otherDetailsType && typeof getDetails?.otherDetailsType === "string"
            ? getDetails?.otherDetailsType
                .split(",")
                .map((value) => {
                    const option = optionsPrefference.find((opt) => opt.value === parseInt(value));
                    return option ? option.label : null;
                })
                .filter((label) => label !== null)
                .join(", ")
            : null;

    const handlefolio = (data, folio) => {
        dynamicUrl(navigate, `accounts/folio?type=${data}&folio=${folio}`)
    }

    const handleProperty = (data) => {
        dynamicUrl(navigate, `viewPropertyDetails?propertyUID=${data}`)
    }
                

    return (
        <div>
            <div className="col-12 px-0 changedateantdstyle">
                <div className="col-12 px-0 daily-date-style">
                    <SubNav
                        title={"Contact Details"}
                        goback={true}
                        extraData={true}
                    />
                    <ToastAlert ref={ToastRef} />

                    <div style={{ display: "flex", padding: "5px", background: 'white', margin: '5px 15px', justifyContent:'space-between' }}>
                        <div style={{ display: "flex"}}>
                            {tabs.map((tab) => (
                                <div
                                    key={tab}
                                    className={`button ${activeTab === tab ? "active-tab" : ""}`}
                                    onClick={() => handleTabs(tab)}
                                >
                                    {tab}
                                </div>
                            ))}
                        </div>
                      
                    </div>
                    {activeTab === "Overview" && (
                        <div className="material-work-desk-new bg-white m-3" style={{ fontFamily: 'Inter' }}>
                            <div className="p-3">
                                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                    <div className="detailsLabel">Personal Details</div>
                                    <div className="editbtn" onClick={() => handleOpenProperty(1)}><EditOutlined className="mr-1" /> Edit</div>
                                </div>

                                <div className="mt-2 detailsContainer">
                                    <ShowValue Label='Contact Type' Data={typeData} setData={getDetails?.contactType} />
                                    <ShowValue Label='Title' Data={titleData} setData={getDetails?.title} />
                                    <ShowValue Label='First Name' setData={getDetails?.firstName} />
                                    <ShowValue Label='Last Name' setData={getDetails?.lastName} />
                                    <ShowValue Label='Type (I am)' setData={commaSeparatedString} />
                                    <ShowValue Label='Phone' setData={getDetails?.mobileNumber} />
                                    <ShowValue Label='Email Address' setData={getDetails?.email} />
                                    <ShowValue Label='Address' setData={getDetails?.address} />
                                </div>
                            </div>

                            <div className="p-3">
                                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                    <div className="detailsLabel">Company Details</div>
                                    <div className="editbtn" onClick={() => handleOpenProperty(1)}><EditOutlined className="mr-1" /> Edit</div>
                                </div>

                                <div className="mt-2 detailsContainer">
                                    <ShowValue Label='ABN' setData={getDetails?.abn} />
                                    <ShowValue Label='ACN' setData={getDetails?.acn} />
                                    <ShowValue Label='Company Name' setData={getDetails?.companyName} />
                                </div>
                            </div>

                            <div className="p-3">
                                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                    <div className="detailsLabel">Preference</div>
                                    <div className="editbtn" onClick={() => handleOpenProperty(1)}><EditOutlined className="mr-1" /> Edit</div>
                                </div>

                                <div className="mt-2 detailsContainer">
                                    <ShowValue Label='Purpose' setData={commaSeparatedString1} />
                                    <ShowValue Label='Budget' Data={budgetData} setData={getDetails?.priceRange} />
                                    <ShowValue Label='State / Region' setData={getDetails?.regions} />
                                    <ShowValue Label='Postcode' setData={selectedCountries} />
                                </div>
                            </div>

                        </div>)}
                    {activeTab === "Owner Folio" && (
                        <div className="material-work-desk-new bg-white m-3" style={{ fontFamily: 'Inter' }}>
                            <div className="p-3">
                                <div className="mt-2 detailsContainer">
                                    <ShowValue Label='Owner Folio' setData={folioDetailsOwner?.ownerAccountFolio} onClick={() => handlefolio("Owner", folioDetailsOwner?.ownerAccountFolio)} link={true} />
                                    <ShowValue Label='Address' setData={folioDetailsOwner?.propertyAddress} onClick={() => handleProperty(folioDetailsOwner?.propertyId)} link={true} />
                                    <ShowValue Label='Balance' setData={folioDetailsOwner?.balance ? folioDetailsOwner?.balance : "-"} amt={true} />
                                    <ShowValue Label='Active' setData={folioDetailsOwner?.isActive ? "Yes" : "No"} />
                                    <ShowValue Label='Last Payment Date' setData={folioDetailsOwner?.lastPaymentDate ? format(new Date(folioDetailsOwner?.lastPaymentDate), 'dd/MM/yyyy hh:mm') : '-'} />
                                    <ShowValue Label='Disbursement' setData={folioDetailsOwner?.disbursementIntervel ? folioDetailsOwner?.disbursementIntervel : "-"} amt={true} />
                                    <ShowValue Label='Withhold Amount' setData={folioDetailsOwner?.withholdAmount ? folioDetailsOwner?.withholdAmount : "-"} amt={true} />
                                </div>
                            </div>

                        </div>)}
                    {activeTab === "Supplier Folio" && (
                        <div className="material-work-desk-new bg-white m-3" style={{ fontFamily: 'Inter' }}>
                            <div className="p-3">
                                <div className="mt-2 detailsContainer">
                                    <ShowValue Label='Account Name' setData={folioDetailsSupplier?.accountName} />
                                    <ShowValue Label='Supplier Folio' setData={folioDetailsSupplier?.accountFolio} onClick={() => handlefolio("Supplier", folioDetailsSupplier?.accountFolio)} link={true} />
                                    <ShowValue Label='Supplier Type' setData={folioDetailsSupplier?.sSupplierType} />
                                    <ShowValue Label='ABN' setData={folioDetailsSupplier?.abn} />
                                    <ShowValue Label='Website' setData={folioDetailsSupplier?.website} />
                                    <ShowValue Label='Balance' setData={folioDetailsSupplier?.balance} amt={true} />
                                    <ShowValue Label='Payment Dues' setData={folioDetailsSupplier?.paymentDues} amt={true} />
                                    <ShowValue Label='Bill Priority' setData={folioDetailsSupplier?.billPriority} />
                                </div>
                            </div>

                        </div>)}
                        {activeTab === "Tenant Folio" && (
                        <div className="material-work-desk-new bg-white m-3" style={{ fontFamily: 'Inter' }}>
                            <div className="p-3">
                                <div className="mt-2 detailsContainer">
                                    <ShowValue Label='Tenant Folio' setData={folioDetailsTenant?.tenantAccountFolio} onClick={() => handlefolio("Tenant", folioDetailsTenant?.tenantAccountFolio)} link={true} />
                                    <ShowValue Label='Address' setData={folioDetailsTenant?.propertyAddress} onClick={() => handleProperty(folioDetailsTenant?.propertyId)} link={true} />
                                    <ShowValue Label='Rent' setData={folioDetailsTenant?.rent ? folioDetailsTenant?.rent : "-"} amt={true} />
                                    <ShowValue Label='Period' setData={folioDetailsTenant?.period} />
                                    <ShowValue Label='Bond Amount' setData={folioDetailsTenant?.bondAmount ? folioDetailsTenant?.bondAmount : "-"} amt={true} />
                                    <ShowValue Label='Move In' setData={folioDetailsTenant?.moveIn ? format(new Date(folioDetailsTenant?.moveIn), 'dd/MM/yyyy hh:mm') : '-'} />
                                    <ShowValue Label='Move Out' setData={folioDetailsTenant?.moveOut ? format(new Date(folioDetailsTenant?.moveOut), 'dd/MM/yyyy hh:mm') : '-'} />
                                    <ShowValue Label='Paid To' setData={folioDetailsTenant?.datePaidTo ? format(new Date(folioDetailsTenant?.datePaidTo), 'dd/MM/yyyy hh:mm') : '-'} />
                                    <ShowValue Label='Deposited' setData={folioDetailsTenant?.deposited ? folioDetailsTenant?.deposited : "-"} amt={true} />
                                </div>
                            </div>

                        </div>)}
                  
                </div>
            </div>
        </div>
    );
};

export default ViewContactDetails;


